<template>
	<div :class="{
		'index':true,
		'index_ott':($store.state.router.type == 'ott'?true:false)
	}">
		<div class="top">
			<div class="top_wrap">
				<div class="top_nav_logo">
					<img :src="logoImg" />
				</div>
				<div class="top_nav_wrap">
					<a
						href="/"
						class="nav_link"
						v-if="$store.state.router.type != 'nas' && $store.state.router.type != 'ott' && $route.query.appid != 'qh360' && $store.state.router.appid != 'ToToLink'"
					>首页</a>
					<a
						href="./"
						class="nav_link active"
						v-if="$store.state.router.type != 'nas' && $store.state.router.type != 'ott' && $route.query.appid != 'qh360' && $store.state.router.appid != 'ToToLink'"
					>玩辰提速</a>
					<a
						href="/help.html"
						class="nav_link"
						v-if="$store.state.router.type != 'nas' && $store.state.router.type != 'ott' && $route.query.appid != 'qh360' && $store.state.router.appid != 'ToToLink'"
					>帮助中心</a>
					<a
						class="nav_link"
						target="_blank"
						href="https://www.ionewu.com"
						title="玩物科技"
						v-if="false"
					>公司官网</a>
					<a
						href="javascript:;"
						:class="{'login_btn':true,'nav_link':true}"
						@click="login"
						v-if="!$store.state.isLogin"
						@touchstart="login"
					>登录</a>
					<a
						href="javascript:;"
						class="nav_link user_info user_info_id"
						@mouseover="showUserMenu"
						@mouseout="hideUserMenu"
						@click="onUserClick"
						v-else-if="$route.query.appid == 'qh360' || $store.state.router.appid == 'ToToLink'"
					>
						<font>ID：{{$store.state.user.uid}}</font>
					</a>
					<a
						href="javascript:;"
						class="nav_link user_info"
						@mouseover="showUserMenu"
						@mouseout="hideUserMenu"
						@click="onUserClick"
						v-else
					>
						<img :src="$store.state.user.headimg" />
						<font>{{$store.state.user.nickname}}</font>
					</a>
					<div
						class="user_menu_bg"
						@mouseover="showUserMenu"
						@mouseout="hideUserMenu"
						v-show="isShowUserMenu && $store.state.router.appid!='QH360V5SRT' && $store.state.router.appid!='ToToLink'"
					></div>

					<div
						class="user_menu"
						@mouseover="showUserMenu"
						@mouseout="hideUserMenu"
						v-show="isShowUserMenu"
					>
						<ul>
							<li
								v-if="$store.state.isPayDown && $refs.bodySwiper && $refs.bodySwiper.swiper.activeIndex == 0"
							>到期时间：{{leftDownTime}}</li>
							<li
								v-if="$store.state.isPayUp && $refs.bodySwiper && $refs.bodySwiper.swiper.activeIndex == 1"
							>到期时间：{{leftUpTime}}</li>
							<li
								class="user_menu_logout"
								v-if="$store.state.router.appid!='QH360V5SRT' && $store.state.router.appid!='ToToLink'"
							>
								<a href="javascript:;" @click="logout" @blur="hideUserMenu">
									<img :src="exitImg" />
									<font>退出</font>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="body_title">
			<img :src="titleImg" />
		</div>
		<div class="swiper_wrap">
			<swiper
				class="swiper-container"
				:options="bodySwiperOption"
				@slideChange="onBodySwiperChange"
				ref="bodySwiper"
			>
				<swiperSlide class="swiper-slide">
					<div class="nav" v-if="false">
						<div class="nav_up" @click="onJumpUpClick">去提上行</div>
					</div>
					<a href="javascript:;" :class="{
						'body_right_arrow':true
					}" @click="onJumpUpClick"></a>
					<div class="body_qrcode" v-if="$store.state.router.appid != 'ToToLink'">
						<p>随时随地</p>
						<p>掌握提速状态</p>
						<p>
							<img :src="qrcodeImg" />
						</p>
						<p>关注玩辰提速</p>
					</div>
					<div class="speed" :style="{'margin-top':speedWrapTop+'px'}">
						<Gauge
							ref="down_gauge"
							:type="'down'"
							:minSpeed="$store.state.nowDownSpeed"
							:maxSpeed="$store.state.toDownSpeed"
							:isShowAction="isShowDownAction"
							:isp="isp"
						></Gauge>
					</div>
					<div v-if="$store.state.isShowDownCheckAnimation">
						<div v-if="$store.state.isCheckSupportDown">
							<div v-if="$store.state.isSupportDown">
								<div v-if="$store.state.isPayDown">
									<div v-if="$store.state.speedDownStatus == 1 && $store.state.speedDownErrno === 0">
										<div class="tips_wrap">
											<span v-if="$store.state.isp == '电信'">中国电信</span>
											<span v-if="$store.state.isp == '联通'">中国联通</span>
											<span>已为您提速至</span>
											<font class="num_tips">{{$store.state.toDownSpeed}}</font>
											<span>Mb</span>
										</div>
										<a href="javascript:;" class="test_btn pay_btn" @click="onBodyPayDownClick">立即续费</a>
										<div v-if="$store.state.bindPid">
											<div
												class="tips_bottom"
												v-if="$store.state.bindAccount == $store.state.localAccount"
											>已绑定当前宽带永久提速中</div>
											<div class="tips_bottom" v-else>正在为已绑定宽带提速</div>
										</div>
										<div v-else>
											<div
												class="tips_bottom"
												v-if="$store.state.bindAccount == $store.state.localAccount"
											>已绑定当前宽带提速中</div>
											<div class="tips_bottom" v-else>正在为已绑定宽带提速</div>
										</div>
									</div>
									<div v-else>
										<div
											v-if="$store.state.bindAccount && $store.state.bindAccount == $store.state.localAccount"
										>
											<div class="tips_wrap">{{$store.state.isp}}宽带异常，效果可能受影响</div>
											<div class="tips_btn_wrap">
												<a
													href="javascript:;"
													class="tips_btn"
													@click="showSamePlaceError"
													@blur="hideSamePlaceError"
												>查看详情</a>
											</div>
										</div>
										<div
											v-else-if="$store.state.bindAccount && $store.state.bindAccount != $store.state.localAccount"
										>
											<div class="tips_wrap">宽带环境变化，请回原宽带下查看</div>
											<div class="tips_btn_wrap">
												<a
													href="javascript:;"
													class="tips_btn"
													@click="showNoSamePlaceError"
													@blur="hideNoSamePlaceError"
												>查看详情</a>
											</div>
										</div>
										<div v-else>
											<div class="tips_wrap">提速失败，请重试</div>
											<a href="javascript:;" class="test_btn" @click="onSpeedDownClick">立即提速</a>
										</div>
									</div>
								</div>
								<div v-else>
									<div v-if="$store.state.isDownTry">
										<div class="tips_wrap">
											<span v-if="$store.state.isp == '电信'">中国电信</span>
											<span v-if="$store.state.isp == '联通'">中国联通</span>
											<span>已为您提速至</span>
											<font class="num_tips">{{$store.state.toDownSpeed}}</font>
											<span>Mb</span>
										</div>
										<div
											class="try_time_wrap"
										>{{downTryHour!="00"?(downTryHour+":"):""}}{{downTryMinute}}:{{downTrySecond}}</div>
										<a
											href="javascript:;"
											class="test_btn pay_btn try_pay_btn"
											@click="onBodyPayDownClick"
										>立即开通</a>
									</div>
									<div v-else-if="$store.state.downTryLeft>0">
										<div class="tips_wrap" v-if="false">
											您有
											<font class="num_tips">1</font>
											次免费提速的机会！
										</div>
										<div class="tips_wrap unpay_tips_wrap">
											宽带可提速至
											<font class="num_tips">{{$store.state.toDownSpeed}}</font>Mb
										</div>
										<a href="javascript:;" class="test_btn" @click="onTryDownClick">立即体验</a>
									</div>
									<div v-else-if="$store.state.isDownTryEnd">
										<div class="tips_wrap try_end_tips_wrap">试用已结束，立即付费尊享永久提速。</div>
										<div class="test_btn pay_btn" @click="onBodyPayDownClick">立即开通</div>
									</div>
									<div v-else>
										<div class="tips_wrap unpay_tips_wrap">
											宽带可提速至
											<font class="num_tips">{{$store.state.toDownSpeed}}</font>Mb
										</div>
										<a href="javascript:;" class="test_btn pay_btn" @click="onBodyPayDownClick">立即开通</a>
									</div>
								</div>
							</div>
							<div v-else>
								<div class="tips_wrap">
									当前宽带不支持提速
									<br />
									<font v-if="$store.state.queryDownCode == 3002">（当前已支持电信、联通家庭宽带）</font>
									<font
										v-else-if="$store.state.queryDownCode == 5002"
									>（{{$store.state.province}}{{$store.state.isp}}不在提速范围内）</font>
									<font v-else>（带宽已到最大或不是家庭宽带）</font>
								</div>
								<!-- <a
									href="javascript:;"
									class="test_btn"
									@click="onBodyDownCheckClick"
									v-if="!$store.state.bindAccount"
								>提速检测</a>-->
								<a
									href="javascript:;"
									class="test_btn help_btn"
									@click="goHelp"
									v-if="!$store.state.bindAccount"
								>查看提速范围</a>
							</div>
						</div>
						<div v-else>
							<a href="javascript:;" class="test_btn" @click="onBodyDownCheckClick">提速检测</a>
						</div>
					</div>
				</swiperSlide>
				<swiperSlide class="swiper-slide">
					<div class="nav" v-if="false">
						<div class="nav_down" @click="onJumpDownClick">去提下行</div>
					</div>
					<a href="javascript:;" :class="{
						'body_left_arrow':true
					}" @click="onJumpDownClick"></a>
					<div class="body_qrcode body_qrcode_left" v-if="$store.state.router.appid != 'ToToLink'">
						<p>随时随地</p>
						<p>掌握提速状态</p>
						<p>
							<img :src="qrcodeImg" />
						</p>
						<p>关注玩辰提速</p>
					</div>
					<div class="speed" :style="{'margin-top':speedWrapTop+'px'}">
						<Gauge
							ref="up_gauge"
							:type="'up'"
							:minSpeed="$store.state.nowUpSpeed"
							:maxSpeed="$store.state.toUpSpeed"
							:isShowAction="isShowUpAction"
							:isp="isp"
						></Gauge>
					</div>
					<div v-if="$store.state.isShowUpCheckAnimation">
						<div v-if="$store.state.isCheckSupportUp">
							<div v-if="$store.state.isSupportUp">
								<div v-if="$store.state.isPayUp">
									<div v-if="$store.state.speedUpStatus == 1 && $store.state.speedUpErrno === 0">
										<div class="tips_wrap">
											<span v-if="$store.state.isp == '电信'">中国电信</span>
											<span v-if="$store.state.isp == '联通'">中国联通</span>
											<span>已为您提速至</span>
											<font class="num_tips">{{$store.state.toUpSpeed}}</font>
											<span>Mb</span>
										</div>
										<a href="javascript:;" class="test_btn pay_btn" @click="onBodyPayUpClick">立即续费</a>
										<div v-if="$store.state.bindPid">
											<div
												class="tips_bottom"
												v-if="$store.state.bindAccount == $store.state.localAccount"
											>已绑定当前宽带永久提速中</div>
											<div class="tips_bottom" v-else>正在为已绑定宽带提速</div>
										</div>
										<div v-else>
											<div
												class="tips_bottom"
												v-if="$store.state.bindAccount == $store.state.localAccount"
											>已绑定当前宽带提速中</div>
											<div class="tips_bottom" v-else>正在为已绑定宽带提速</div>
										</div>
									</div>
									<div v-else>
										<div
											v-if="$store.state.bindAccount && $store.state.bindAccount == $store.state.localAccount"
										>
											<div class="tips_wrap">{{$store.state.isp}}宽带异常，效果可能受影响</div>
											<div class="tips_btn_wrap">
												<a
													href="javascript:;"
													class="tips_btn"
													@click="showSamePlaceError"
													@blur="hideSamePlaceError"
												>查看详情</a>
											</div>
										</div>
										<div
											v-else-if="$store.state.bindAccount && $store.state.bindAccount != $store.state.localAccount"
										>
											<div class="tips_wrap">宽带环境变化，请回原宽带下查看</div>
											<div class="tips_btn_wrap">
												<a
													href="javascript:;"
													class="tips_btn"
													@click="showNoSamePlaceError"
													@blur="hideNoSamePlaceError"
												>查看详情</a>
											</div>
										</div>
										<div v-else>
											<div class="tips_wrap">提速失败，请重试</div>
											<a href="javascript:;" class="test_btn" @click="onSpeedUpClick">立即提速</a>
										</div>
									</div>
								</div>
								<div v-else>
									<div v-if="$store.state.isUpTry">
										<div class="tips_wrap">
											<span v-if="$store.state.isp == '电信'">中国电信</span>
											<span v-if="$store.state.isp == '联通'">中国联通</span>
											<span>已为您提速至</span>
											<font class="num_tips">{{$store.state.toUpSpeed}}</font>
											<span>Mb</span>
										</div>
										<div
											class="try_time_wrap"
										>{{upTryHour!="00"?(upTryHour+":"):""}}{{upTryMinute}}:{{upTrySecond}}</div>
										<a href="javascript:;" class="test_btn pay_btn try_pay_btn" @click="onBodyPayUpClick">立即开通</a>
									</div>
									<div v-else-if="$store.state.upTryLeft>0">
										<div class="tips_wrap" v-if="false">
											您有
											<font class="num_tips">1</font>
											次免费提速的机会！
										</div>
										<div class="tips_wrap unpay_tips_wrap">
											宽带可提速至
											<font class="num_tips num_tips">{{$store.state.toUpSpeed}}</font>Mb
										</div>
										<a href="javascript:;" class="test_btn" @click="onTryUpClick">立即体验</a>
									</div>

									<div v-else-if="$store.state.isUpTryEnd">
										<div class="tips_wrap try_end_tips_wrap">试用已结束，立即付费尊享永久提速。</div>
										<a href="javascript:;" class="test_btn pay_btn" @click="onBodyPayUpClick">立即开通</a>
									</div>

									<div v-else>
										<div class="tips_wrap unpay_tips_wrap">
											宽带可提速至
											<font class="num_tips">{{$store.state.toUpSpeed}}</font>Mb
										</div>
										<a href="javascript:;" class="test_btn pay_btn" @click="onBodyPayUpClick">立即开通</a>
									</div>
								</div>
							</div>
							<div v-else>
								<div class="tips_wrap">
									当前宽带不支持提速
									<br />
									<font v-if="$store.state.queryUpCode == 3002">（当前已支持电信、联通家庭宽带）</font>
									<font
										v-else-if="$store.state.queryUpCode == 5002"
									>（{{$store.state.province}}{{$store.state.isp}}不在提速范围内）</font>
									<font v-else>（带宽已到最大或不是家庭宽带）</font>
								</div>
								<!-- <a
									href="javascript:;"
									class="test_btn"
									@click="onBodyUpCheckClick"
									v-if="!$store.state.bindAccount"
								>提速检测</a>-->
								<a
									href="javascript:;"
									class="test_btn help_btn"
									@click="goHelp"
									v-if="!$store.state.bindAccount"
								>查看提速范围</a>
							</div>
						</div>
						<div v-else>
							<a href="javascript:;" class="test_btn" @click="onBodyUpCheckClick">提速检测</a>
						</div>
					</div>
				</swiperSlide>
			</swiper>
		</div>
		<transition name="fadein">
			<Pay v-if="$store.state.isShowPay" @payUpEnd="payUpEnd" @payDownEnd="payDownEnd"></Pay>
		</transition>
		<div class="error_tips_alert" @click="hideSamePlaceError" v-if="isShowSamePlaceError">
			<a href="javascript:;" class="error_tips_alert_content">
				检测到您的宽带异常，如果提速效果不好，建议您
				<b>重启光猫和路由器</b>，然后重新打开提速页面
			</a>
		</div>
		<div class="error_tips_alert" @click="hideNoSamePlaceError" v-if="isShowNoSamePlaceError">
			<a href="javascript:;" class="error_tips_alert_content">
				检测到您的宽带发生变化，请回原宽带查看提速效果，如果已经在提速宽带下，建议您
				<b>重启光猫和路由器</b>，然后重新打开提速页面
			</a>
		</div>
		<Trial
			@onTrialClick="onTrialClick"
			@onCloseClick="closeTrialAlert"
			v-if="isShowTrialAlert && $store.state.router.appid!='QH360V5SRT' && $store.state.router.appid!='ToToLink' "
		></Trial>
	</div>
</template>

<script>
import Gauge from "../components/Gauge.vue";
import Pay from "../components/Pay.vue";
import Trial from "../components/Trial.vue";

import { mapActions } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
	components: {
		Gauge,
		Pay,
		swiper,
		swiperSlide,
		Trial
	},
	data: function() {
		return {
			logoImg: require("../assets/logo.png"),
			titleImg: require("../assets/title.png"),
			arrowImg: require("../assets/arrow.png"),
			qrcodeImg: require("../assets/qrcode.jpg"),
			exitImg: require("../assets/exit_btn.png"),
			isShowUpAction: false,
			isShowDownAction: false,
			isShowSamePlaceError: false,
			isShowNoSamePlaceError: false,
			isShowTrialAlert: false,
			topSwiper: null,
			leftUpTime: "",
			leftDownTime: "",
			upTryIntervaler: null,
			upTryHour: "00",
			upTryMinute: "00",
			upTrySecond: "00",
			downTryIntervaler: null,
			downTryHour: "00",
			downTryMinute: "00",
			downTrySecond: "00",
			swiperOption: {
				direction: "vertical",
				autoplay: false,
				loop: false,
				speed: 1000
			},
			bodySwiperOption: {
				direction: "horizontal",
				autoplay: false,
				loop: false,
				speed: 1000,
				on: {
					slideChangeTransitionEnd: this
						.onBodySlideChangeTransitionEnd
				}
			},
			isFirstGetInfo: true,
			isShowUserMenu: false
		};
	},
	computed: {
		isp: function() {
			return (
				this.$store.state.province.replace("省", "") +
				this.$store.state.isp
			);
		},
		upTryLeft: function() {
			let _that = this;
			let timestamp = parseInt(new Date().getTime() / 1000);
			let second = _that.$store.state.upTryTimestamp - timestamp;
			return second > 0 ? second : 0;
		},
		downTryLeft: function() {
			let _that = this;
			let timestamp = parseInt(new Date().getTime() / 1000);
			let second = _that.$store.state.downTryTimestamp - timestamp;
			return second > 0 ? second : 0;
		},
		speedWrapTop: function() {
			let height = window.innerHeight;
			let width = window.innerWidth;
			let ratio = height / width;
			if (ratio > 1.8) {
				return height * ratio * 0.04;
			} else {
				return 0;
			}
		},
		leftText: function() {
			if (this.$refs.bodySwiper) {
				if (this.$refs.bodySwiper.swiper.activeIndex == 0) {
					return this.leftDownTime;
				} else {
					return this.leftUpTime;
				}
			} else {
				return "";
			}
		}
	},
	watch: {
		"$store.state.upPay.left": function(newVal) {
			this.leftUpTime = this.getLeftTimeTips(newVal);
		},
		"$store.state.downPay.left": function(newVal) {
			this.leftDownTime = this.getLeftTimeTips(newVal);
		},
		"$store.state.speedUpStatus": function(newVal) {
			let _that = this;
			if (newVal == 1 && this.$store.state.speedUpErrno === 0) {
				setTimeout(function() {
					_that.isShowUpAction = true;
					_that.$refs.up_gauge.renderAll();
					// _that.$refs.up_gauge.startPointerAction();
				}, 1000);
			} else {
				// _that.isShowUpAction = false;
				// _that.$refs.up_gauge.renderAll();
				_that.$refs.up_gauge.stopPointerAction();
			}
		},
		"$store.state.speedDownStatus": function(newVal) {
			let _that = this;
			if (newVal == 1 && this.$store.state.speedDownErrno === 0) {
				setTimeout(function() {
					_that.isShowDownAction = true;
					_that.$refs.down_gauge.renderAll();
					// _that.$refs.down_gauge.startPointerAction();
				}, 1000);
			} else {
				// _that.isShowDownAction = false;
				// _that.$refs.down_gauge.renderAll();
				_that.$refs.down_gauge.stopPointerAction();
			}
		},
		"$store.state.isUpTry": function(newVal) {
			if (newVal == true) {
				this.isShowUpAction = true;
				this.$refs.up_gauge.renderAll();
				// this.$refs.up_gauge.startPointerAction();
			} else {
				this.isShowUpAction = false;
				this.$refs.up_gauge.renderAll();
				this.$refs.up_gauge.stopPointerAction();
			}
		},
		"$store.state.isDownTry": function(newVal) {
			if (newVal == true) {
				this.isShowDownAction = true;
				this.$refs.down_gauge.renderAll();
				// this.$refs.down_gauge.startPointerAction();
			} else {
				this.isShowDownAction = false;
				this.$refs.down_gauge.renderAll();
				this.$refs.down_gauge.stopPointerAction();
			}
		}
	},
	mounted: function() {
		let _that = this;
		_that.sendUserlog(["open", document.location.href]);
		if (!_that.$store.state.user.uid) {
			_that.$store.state.user.uid =
				parseInt(Math.random() * 100000000) + "";
			localStorage.setItem("kd2-uid", _that.$store.state.user.uid);
		}
		_that.beforeInit();
		_that.checkUserDev();
		setTimeout(function() {
			// _that.$store.state.isPayDown = true;
			// _that.$store.state.downTryLeft = 10000;
		}, 20 * 1000);
	},
	methods: {
		...mapActions([
			"getUserInfo",
			"getUserInfoUp",
			"getUserInfoDown",
			"getUserDev",
			"findLanDevice",
			"addUserDev",
			"setPidInfo",
			"getSpeedStatus",
			"getTryInfo",
			"getTryOpen",
			"getSpeedOpen",
			"sendUserlog",
			"getGiftInfo",
			"getGift",
			"getLocalAccount",
			"getUserLeft",
			"getUserLeftUp",
			"getUserLeftDown",
			"goLogin",
			"getLogout"
		]),
		onBodySlideChangeTransitionEnd: function() {
			let index = this.$refs.bodySwiper.swiper.activeIndex;
			// console.log(index);
			if (index === 1) {
				if (!this.$store.state.isCheckSupportUp) {
					this.getUserUpInfo();
				}
			}
		},
		beforeInit: function() {
			let _that = this;
			_that.$store.state.isShowLoading = true;
			_that.getLocalAccount([
				function(err) {
					if (err) {
						console.log(err);
						_that.$store.state.isShowLoading = false;
						_that.$toast("发送请求失败，请检查网络");
						return;
					}
					_that.init();
				}
			]);
			// if (
			// 	_that.$store.state.router.appid == "QH360V5SRT" ||
			// 	_that.$store.state.router.appid == "ToToLink"
			// ) {
			// 	_that.init();
			// } else {
			// 	_that.getLocalAccount([
			// 		function(err) {
			// 			if (err) {
			// 				console.log(err);
			// 				_that.$store.state.isShowLoading = false;
			// 				_that.$toast("发送请求失败，请检查网络");
			// 				return;
			// 			}
			// 			_that.init();
			// 		}
			// 	]);
			// }
		},
		init: function() {
			let _that = this;
			_that.getUserDownInfo();
			setTimeout(function() {
				_that.initTryInfo();
				_that.initRouterInfo();
				// _that.fetchGiftInfo();
			}, 1000);
		},
		getUserDownInfo: function() {
			let _that = this;
			_that.$store.state.isShowLoading = true;
			_that.$store.state.isShowDownCheckAnimation = false;
			_that.getSpeedStatus([
				2,
				function(err) {
					if (err) {
						console.log(err);
						_that.$store.state.isShowLoading = false;
						_that.$toast("发送请求失败，请检查网络");
						return;
					}
					_that.getUserInfoDown([
						function() {
							if (err) {
								console.log(err);
								_that.$store.state.isShowLoading = false;
								_that.$toast("发送请求失败，请检查网络");
								return;
							}
							_that.doAfterGetUserDownInfo();
							_that.$store.state.isShowLoading = false;
						}
					]);
				}
			]);
		},
		doAfterGetUserDownInfo: function() {
			let _that = this;
			if (_that.$store.state.isPayDown) {
				if (
					_that.$store.state.speedDownStatus === 0 ||
					_that.$store.state.speedDownErrno !== 0
				) {
					_that.fetchSpeedOpen(2);
				} else if (
					_that.$store.state.bindAccount &&
					_that.$store.state.bindAccount ==
						_that.$store.state.localAccount
				) {
					_that.fetchSpeedOpen(2);
				}
			} else {
				if (
					!_that.$store.state.isDownTry &&
					_that.$store.state.isSupportDown
				) {
					_that.fetchTryInfo(2, function(err, data) {
						if (
							_that.$store.state.isSupportDown &&
							!_that.$store.state.isPayDown &&
							_that.$store.state.downTryLeft > 0
						) {
							_that.sendUserlog([
								"check_try_down_success",
								JSON.stringify(data)
							]);
							let action = _that.$route.query.action;
							if (action == "trial_down") {
								_that.onTryDownClick();
							} else {
								_that.isShowTrialAlert = true;
							}
						}
					});
				}
			}
			_that.renderGaugeDown();
		},
		getUserUpInfo: function() {
			let _that = this;
			_that.$store.state.isShowLoading = true;
			_that.$store.state.isShowUpCheckAnimation = false;
			_that.getSpeedStatus([
				1,
				function(err) {
					if (err) {
						console.log(err);
						_that.$store.state.isShowLoading = false;
						_that.$toast("发送请求失败，请检查网络");
						return;
					}
					_that.getUserInfoUp([
						function() {
							if (err) {
								console.log(err);
								_that.$store.state.isShowLoading = false;
								_that.$toast("发送请求失败，请检查网络");
								return;
							}
							_that.doAfterGetUserUpInfo();
							_that.$store.state.isShowLoading = false;
						}
					]);
				}
			]);
		},
		doAfterGetUserUpInfo: function() {
			let _that = this;
			if (_that.$store.state.isPayUp) {
				if (
					_that.$store.state.speedUpStatus === 0 ||
					_that.$store.state.speedUpErrno !== 0
				) {
					_that.fetchSpeedOpen(1);
				} else if (
					_that.$store.state.bindAccount &&
					_that.$store.state.bindAccount ==
						_that.$store.state.localAccount
				) {
					_that.fetchSpeedOpen(1);
				}
			} else {
				if (
					!_that.$store.state.isUpTry &&
					_that.$store.state.isSupportUp
				) {
					_that.fetchTryInfo(1, function(err, data) {
						if (
							_that.$store.state.isSupportUp &&
							!_that.$store.state.isPayUp &&
							_that.$store.state.upTryLeft > 0
						) {
							_that.sendUserlog([
								"check_try_up_success",
								JSON.stringify(data)
							]);
							let action = _that.$route.query.action;
							if (action == "trial_up") {
								_that.onTryUpClick();
							}
						}
					});
				}
			}

			_that.renderGaugeUp();
		},
		// 自动绑定设备
		checkUserDev: function(cb) {
			let _that = this;
			if (!_that.$store.state.user.openid) {
				return;
			}
			this.getUserDev([
				function(err, data) {
					if (err) {
						console.log(err);
						_that.$toast("发送请求失败，请检查网络");
						return;
					}
					// console.log(data);
					let bindDevs = [];
					if (data.rtn == 0 && data.data && data.data.length > 0) {
						for (let index = 0; index < data.data.length; index++) {
							let dev = data.data[index];
							bindDevs.push(dev.pid);
						}
					}
					_that.findLanDevice([
						function(err, data) {
							if (err) {
								_that.$toast("发送请求失败，请检查网络");
								return;
							}
							let lanDevs = [];
							if (
								data.rtn == 0 &&
								data.data &&
								data.data.length > 0
							) {
								for (
									let index = 0;
									index < data.data.length;
									index++
								) {
									let dev = data.data[index];
									lanDevs.push(dev.pid);
									let isBind = false;
									for (let j = 0; j < bindDevs.length; j++) {
										let bindDevPid = bindDevs[j];
										if (bindDevPid == dev.pid) {
											isBind = true;
										}
									}
									if (!isBind) {
										_that.addUserDev([
											dev.pid,
											function(err) {
												if (err) {
													console.log(err);
													return;
												}
											}
										]);
									}
								}
							}
							cb ? cb() : null;
						}
					]);
				}
			]);
		},
		initTryInfo: function() {
			let _that = this;
			if (_that.$store.state.isDownTry) {
				_that.startDownTryInterval();
			}
			if (_that.$store.state.isUpTry) {
				_that.startUpTryInterval();
			}
		},
		initRouterInfo: function() {
			// console.log("initRouterInfo");
			let _that = this;
			if (
				_that.$route.query.action == "up" ||
				_that.$route.query.action == "pay_up"
			) {
				_that.jumpUpPage();
			} else if (
				_that.$route.query.action == "down" ||
				_that.$route.query.action == "pay_down"
			) {
				_that.jumpDownPage();
			} else if (
				_that.$store.state.isPayUp &&
				!_that.$store.state.isPayDown
			) {
				_that.jumpUpPage();
			}
		},
		startUpTryInterval: function() {
			let _that = this;
			_that.buildUpTryTime();
			_that.upTryIntervaler = setInterval(function() {
				_that.$store.state.upTryLeft--;
				// console.log(_that.$store.state.upTryLeft);
				_that.buildUpTryTime();
				if (_that.$store.state.upTryLeft <= 0) {
					clearInterval(_that.upTryIntervaler);
					_that.$store.state.isUpTry = false;
					_that.$store.state.isUpTryEnd = true;
				}
			}, 1000);
		},
		buildUpTryTime: function() {
			let _that = this;
			_that.upTryHour = parseInt(_that.$store.state.upTryLeft / 3600);
			_that.upTryHour =
				_that.upTryHour < 10 ? "0" + _that.upTryHour : _that.upTryHour;
			_that.upTryMinute = parseInt(
				(_that.$store.state.upTryLeft - _that.upTryHour * 3600) / 60
			);
			_that.upTryMinute =
				_that.upTryMinute < 10
					? "0" + _that.upTryMinute
					: _that.upTryMinute;
			_that.upTrySecond = parseInt(
				_that.$store.state.upTryLeft -
					_that.upTryHour * 3600 -
					_that.upTryMinute * 60
			);
			_that.upTrySecond =
				_that.upTrySecond < 10
					? "0" + _that.upTrySecond
					: _that.upTrySecond;
		},
		startDownTryInterval: function() {
			let _that = this;
			_that.buildDownTryTime();
			_that.downTryIntervaler = setInterval(function() {
				_that.$store.state.downTryLeft--;
				_that.buildDownTryTime();
				if (_that.$store.state.downTryLeft <= 0) {
					clearInterval(_that.downTryIntervaler);
					_that.$store.state.isDownTry = false;
					_that.$store.state.isDownTryEnd = true;
				}
			}, 1000);
		},
		buildDownTryTime: function() {
			let _that = this;
			_that.downTryHour = parseInt(_that.$store.state.downTryLeft / 3600);
			_that.downTryHour =
				_that.downTryHour < 10
					? "0" + _that.downTryHour
					: _that.downTryHour;
			_that.downTryMinute = parseInt(
				(_that.$store.state.downTryLeft - _that.downTryHour * 3600) / 60
			);
			_that.downTryMinute =
				_that.downTryMinute < 10
					? "0" + _that.downTryMinute
					: _that.downTryMinute;
			_that.downTrySecond = parseInt(
				_that.$store.state.downTryLeft -
					_that.downTryHour * 3600 -
					_that.downTryMinute * 60
			);
			_that.downTrySecond =
				_that.downTrySecond < 10
					? "0" + _that.downTrySecond
					: _that.downTrySecond;
		},
		getLeftTimeTips: function(time) {
			if (time > 24 * 60 * 60) {
				return "" + Math.ceil(time / (24 * 60 * 60)) + "天";
			} else if (time > 0) {
				return "" + Math.ceil(time / (60 * 60)) + "小时";
			} else {
				return "已到期";
			}
		},
		onTopSwiperChange: function() {
			// this.$refs.bodySwiper.swiper.slideTo(
			// 	this.$refs.mySwiper.swiper.activeIndex
			// );
		},
		onBodySwiperChange: function() {
			// this.$refs.mySwiper.swiper.slideTo(
			// 	this.$refs.bodySwiper.swiper.activeIndex
			// );
		},
		showUserMenu: function() {
			this.isShowUserMenu = true;
		},
		hideUserMenu: function() {
			this.isShowUserMenu = false;
		},
		onUserClick: function() {
			if (this.isShowUserMenu) {
				this.isShowUserMenu = false;
			} else {
				this.isShowUserMenu = true;
			}
		},
		onTrialClick: function() {
			let _that = this;
			_that.sendUserlog(["trial_alert_btn_click", ""]);
			_that.isShowTrialAlert = false;
			_that.onTryDownClick();
		},
		goHelp: function() {
			window.open("/help.html?appid=" + this.$store.state.router.appid);
		},
		closeTrialAlert: function() {
			let _that = this;
			_that.isShowTrialAlert = false;
			_that.sendUserlog(["hide_trial_alert", ""]);
		},
		showSamePlaceError: function() {
			let _that = this;
			_that.sendUserlog(["show_error_tips_click", ""]);
			_that.isShowSamePlaceError = true;
		},
		showNoSamePlaceError: function() {
			let _that = this;
			_that.sendUserlog(["show_error_tips_click", ""]);
			_that.isShowNoSamePlaceError = true;
		},
		hideSamePlaceError: function() {
			let _that = this;
			_that.sendUserlog(["hide_error_tips_click", ""]);
			_that.isShowSamePlaceError = false;
		},
		hideNoSamePlaceError: function() {
			let _that = this;
			_that.sendUserlog(["hide_error_tips_click", ""]);
			_that.isShowNoSamePlaceError = false;
		},
		onTryUpClick: function() {
			let _that = this;
			_that.sendUserlog(["try_up_btn_click", ""]);
			_that.fetchTryOpen(1);
		},
		onTryDownClick: function() {
			let _that = this;
			_that.sendUserlog(["try_down_btn_click", ""]);
			_that.fetchTryOpen(2);
		},
		onSpeedUpClick: function() {
			let _that = this;
			_that.sendUserlog(["open_up_btn_click", ""]);
			_that.fetchSpeedOpen(1);
		},
		onSpeedDownClick: function() {
			let _that = this;
			_that.sendUserlog(["open_down_btn_click", ""]);
			_that.fetchSpeedOpen(2);
		},
		onTopPayUpClick: function() {
			let _that = this;
			_that.sendUserlog(["top_pay_up_btn_click", ""]);
			_that.onPayUpClick();
		},
		onTopPayDownClick: function() {
			let _that = this;
			_that.sendUserlog(["top_pay_down_btn_click", ""]);
			_that.onPayDownClick();
		},
		onBodyPayUpClick: function() {
			let _that = this;
			_that.sendUserlog(["body_pay_up_btn_click", ""]);
			_that.onPayUpClick();
		},
		onBodyPayDownClick: function() {
			let _that = this;
			_that.sendUserlog(["body_pay_down_btn_click", ""]);
			_that.onPayDownClick();
		},
		onPayUpClick: function() {
			let _that = this;
			_that.$store.state.payType = "up";
			_that.showPay();
		},
		onPayDownClick: function() {
			let _that = this;
			_that.$store.state.payType = "down";
			_that.showPay();
		},
		onUpPayClick: function() {
			this.$store.state.payType = "up";
			this.showPay();
		},
		onDownPayClick: function() {
			this.$store.state.payType = "down";
			this.showPay();
		},
		showPay: function() {
			if (!this.$store.state.isLogin) {
				this.goLogin([]);
				return;
			}
			this.$store.state.isShowPay = true;
		},
		onJumpUpClick: function() {
			let _that = this;
			_that.sendUserlog(["jump_up_btn_click", ""]);
			_that.jumpUpPage();
		},
		onJumpDownClick: function() {
			let _that = this;
			_that.sendUserlog(["jump_down_btn_click", ""]);
			_that.jumpDownPage();
		},
		jumpUpPage: function() {
			this.$refs.bodySwiper.swiper.slideTo(1);
		},
		jumpDownPage: function() {
			this.$refs.bodySwiper.swiper.slideTo(0);
		},
		onTopDownCheckClick: function() {
			let _that = this;
			_that.sendUserlog(["top_check_down_btn_click", ""]);
			_that.$store.state.isCheckSupportDown = false;
			_that.getUserDownInfo();
		},
		onTopUpCheckClick: function() {
			let _that = this;
			_that.sendUserlog(["top_check_up_btn_click", ""]);
			_that.$store.state.isCheckSupportUp = false;
			_that.getUserUpInfo();
		},
		onBodyDownCheckClick: function() {
			let _that = this;
			_that.sendUserlog(["body_check_down_btn_click", ""]);
			_that.$store.state.isCheckSupportDown = false;
			_that.getUserDownInfo();
		},
		onBodyUpCheckClick: function() {
			let _that = this;
			_that.sendUserlog(["body_check_up_btn_click", ""]);
			_that.$store.state.isCheckSupportUp = false;
			_that.getUserUpInfo();
		},
		renderGaugeUp: function() {
			let _that = this;
			if (_that.$refs.up_gauge) {
				_that.$refs.up_gauge.renderAll();
			}
		},
		renderGaugeDown: function() {
			let _that = this;
			if (_that.$refs.down_gauge) {
				_that.$refs.down_gauge.renderAll();
			}
		},
		fetchTryInfo: function(type, cb) {
			let _that = this;
			// 已绑定账号并且不在同一宽带，不能试用
			// console.log(_that.$store.state.bindAccount);
			// console.log(_that.$store.state.localAccount);
			if (
				_that.$store.state.bindAccount &&
				_that.$store.state.bindAccount !=
					_that.$store.state.localAccount
			) {
				return;
			}
			_that.getTryInfo([type, cb]);
		},
		fetchTryOpen: function(type) {
			let _that = this;
			_that.$store.state.isShowLoading = true;
			_that.getTryOpen([
				type,
				function(err, data) {
					_that.$store.state.isShowLoading = false;
					if (err) {
						_that.$toast("发送请求失败，请检查网络");
						return;
					}
					if (data.code === 0) {
						let timestamp = parseInt(new Date().getTime() / 1000);
						if (type === 1) {
							timestamp =
								timestamp + _that.$store.state.upTryLeft;
							_that.$store.state.upTryTimestamp = timestamp;
							localStorage.setItem(
								"kd-upTryTimestamp",
								timestamp
							);
							_that.startUpTryInterval();
						} else if (type === 2) {
							timestamp =
								timestamp + _that.$store.state.downTryLeft;
							_that.$store.state.downTryTimestamp = timestamp;
							localStorage.setItem(
								"kd-downTryTimestamp",
								timestamp
							);
							_that.startDownTryInterval();
						}
					} else {
						_that.$toast("试用提速失败");
					}
				}
			]);
		},
		fetchSpeedOpen: function(type) {
			let _that = this;
			_that.$store.state.isShowLoading = true;
			_that.getSpeedOpen([
				type,
				function(err, data) {
					_that.$store.state.isShowLoading = false;
					if (err) {
						_that.$toast("发送请求失败，请检查网络");
						return;
					}

					if (data.code !== 0) {
						_that.$toast("提速失败 " + data.code);
					}
				}
			]);
		},
		fetchGiftInfo: function() {
			let _that = this;
			_that.getGiftInfo([
				function(err, data) {
					if (!err) {
						if (data.data.gift_time > 0) {
							_that.$store.state.isShowGuoqing = true;
						} else {
							_that.$store.state.isShowGuoqing = false;
						}
					}
				}
			]);
		},
		payUpEnd: function() {
			let _that = this;
			_that.$store.state.isGetUserLeftUp = false;
			_that.$store.state.isPayNow = true;
			_that.getUserUpInfo();
		},
		payDownEnd: function() {
			let _that = this;
			_that.$store.state.isGetUserLeftDown = false;
			_that.$store.state.isPayNow = true;
			_that.getUserDownInfo();
		},
		logout: function() {
			let _that = this;
			_that.sendUserlog(["logout_click", ""]);
			_that.getLogout([]);
		},
		login: function() {
			let _that = this;
			_that.goLogin([]);
		}
	}
};
</script>

<style lang="less" scoped>
.index {
	width: 100%;
	height: 100%;
	background-position: center center;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-image: url("../assets/bg.jpg");
	overflow: hidden;

	.top {
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
	}

	.top_wrap {
		width: 100%;
		max-width: 1150px;
		height: 100px;
		margin: 0 auto;
	}

	.top_nav_logo {
		display: inline-block;
		vertical-align: top;
		margin-top: 20px;
	}

	.top_wrap .top_nav_wrap {
		margin-top: 20px;
		float: right;
		vertical-align: top;
		position: relative;
	}

	.top_nav_wrap .nav_link {
		margin-left: 60px;
		height: 30px;
		line-height: 30px;
		color: #999999;
		display: inline-block;
	}

	.top_nav_wrap .nav_link.active,
	.top_nav_wrap .nav_link:hover {
		color: #ffffff;
	}

	.top_nav_wrap .login_btn {
		background-color: #efc65d;
		padding: 0px 20px;
		height: 30px;
		line-height: 30px;
		color: #ffffff;
		border-radius: 15px;
	}

	// .user_info:hover {
	// 	.user_menu,
	// 	.user_menu_bg {
	// 		display: block;
	// 	}
	// }

	.user_info {
		position: relative;
		margin-right: 10px;

		img {
			width: 26px;
			border-radius: 13px;
			vertical-align: middle;
			margin-right: 5px;
		}
		font {
			vertical-align: middle;
			max-width: 100px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			display: inline-block;
		}
	}
	.user_info_id {
		font {
			max-width: 100px;
		}
	}

	.user_menu_bg {
		position: absolute;
		top: 20px;
		right: 20px;
		background: #fafafa;
		width: 10px;
		height: 10px;
		transform: rotate(45deg);
	}

	.user_menu {
		position: absolute;
		right: 0;
		top: 25px;
		color: #666666;
		width: 130px;
		text-align: center;
		font-size: 12px;
		overflow: hidden;
		border-radius: 5px;
		background: #fafafa;

		ul {
			list-style: none;

			li {
				height: 30px;
				line-height: 26px;
				border-bottom: 1px dotted #dddddd;
			}

			li:hover {
				background-color: #eeeeee;
			}

			.user_menu_logout {
				a {
					color: #666666;
					display: block;
					img {
						width: 14px;
						vertical-align: middle;
						margin-right: 5px;
					}
					font {
						vertical-align: middle;
					}
				}
				a:hover {
					color: #666666;
				}
			}
		}
	}

	#body_container {
		width: 100%;
		height: 100%;
	}

	.body_title {
		width: 80%;
		max-width: 886px;
		margin: 0 auto;
		margin-top: 160px;
		margin-bottom: 30px;

		img {
			width: 100%;
		}
	}

	.swiper_wrap {
		width: 100%;
		max-width: 1150px;
		margin: 0 auto;
	}

	.body_qrcode {
		width: 175px;
		background-color: rgba(255, 255, 255, 0.1);
		font-size: 20px;
		text-align: center;
		padding: 10px 0;
		position: absolute;
		right: 50px;
		top: 70px;
		color: #bebfc2;
		border-radius: 5px;

		img {
			margin: 10px auto;
			width: 128px;
		}
	}

	.body_qrcode_left {
		right: auto;
		left: 50px;
	}

	.body_left_arrow {
		position: absolute;
		left: 290px;
		top: 170px;
		cursor: pointer;
		z-index: 90;
		display: block;
		width: 50px;
		height: 85px;
		background-image: url(../assets/arrow_left.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.body_left_arrow:hover {
		opacity: 0.5;
	}

	.body_right_arrow {
		position: absolute;
		right: 290px;
		top: 170px;
		cursor: pointer;
		z-index: 90;
		display: block;
		width: 50px;
		height: 85px;
		background-image: url(../assets/arrow.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.body_right_arrow:hover {
		opacity: 0.5;
	}

	.gauge_wrap {
		margin-top: 50px;
	}

	.speed {
		font-size: 0;
		.speed_info {
			display: inline-block;
			width: 300px;
			vertical-align: top;
			height: 340px;
			overflow: hidden;
			font-size: 24px;
			color: #fff;
			text-align: center;
			// background-image: url(../assets/arrow.png);
			background-position: center center;
			background-repeat: no-repeat;
			background-size: 40px 40px;

			.type {
				margin-top: 60px;
				font-size: 32px;
			}

			.now_speed {
				margin-top: 0px;
			}

			.to_speed {
				margin-top: 40px;
				margin-bottom: 40px;

				img {
					width: 40px;
					margin-left: 10px;
					margin-right: 10px;
				}

				font {
					color: #dbbf8f;
					font-size: 32px;
				}
			}
			.un_check_1 {
				margin-top: 180px;
				color: #dbbf8f;
			}
			.un_check_2 {
				margin-top: 30px;
				font-size: 32px;
			}
			.un_support_1 {
				margin-top: 40px;
				img {
					width: 60px;
				}
			}
			.un_support_2 {
				margin-top: 15px;
			}
			.btn {
				width: 210px;
				height: 60px;
				line-height: 60px;
				text-align: center;
				line-height: 60px;
				border: 2px solid #fff;
				border-radius: 30px;
				margin: 0 auto;
				margin-top: 30px;
			}
			.do_btn {
				background: linear-gradient(to right, #dbbf8f, #caaa66);
				color: #392700;
				border: 0;
			}
		}
	}
	.down_speed {
		margin-top: 70px;
	}
	.tips_wrap {
		width: 100%;
		text-align: center;
		font-size: 18px;
		color: #cccccc;
		margin-top: -40px;
		font {
			font-size: 14px;
		}
		.num_tips {
			margin: 0 15px 0 15px;
			color: #fccc59;
			font-size: 30px;
			font-style: italic;
		}
	}
	.tips_btn_wrap {
		text-align: center;
		margin-top: 40px;
		.tips_btn {
			text-align: center;
			font-size: 14px;
			color: #cccccc;
			text-decoration: underline;
		}
	}
	.try_end_tips_wrap {
		margin-top: 0px;
		margin-bottom: 60px;
	}
	.unpay_tips_wrap {
		margin-top: -40px;
		margin-bottom: 60px;
	}
	.try_time_wrap {
		width: 320px;
		height: 70px;
		line-height: 70px;
		font-size: 20px;
		color: #cccccc;
		border-radius: 35px;
		text-align: center;
		margin: 0 auto;
		margin-top: 20px;
		margin-bottom: -80px;
	}
	.tips_bottom {
		width: 100%;
		text-align: center;
		font-size: 14px;
		color: #cccccc;
		margin-top: 5px;
	}
	.test_btn {
		width: 230px;
		height: 66px;
		line-height: 66px;
		border-radius: 33px;
		// font-weight: bolder;
		font-size: 32px;
		color: #ffffff;
		text-align: center;
		margin: 0 auto;
		margin-top: 40px;
		margin-bottom: 30px;
		background-color: #efc65d;
		background-image: url(../assets/check_btn.png);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;
		overflow: hidden;
		z-index: 11;
		cursor: pointer;
		display: block;
	}
	.help_btn {
		font-size: 24px;
	}
	.pay_btn:after {
		content: "";
		transform: rotate(45deg);
		position: absolute;
		top: -30px;
		left: -80px;
		height: 160px;
		width: 50px;
		background: linear-gradient(
			90deg,
			hsla(0, 0%, 100%, 0),
			hsla(0, 0%, 100%, 0.5),
			hsla(0, 0%, 100%, 0)
		);
		animation: btnlight 1.5s 1.5s linear infinite;
	}

	.pay_btn {
		color: #ffffff;
		background-image: none;
		background-color: #ff2930;
	}

	.try_pay_btn {
		background-image: none;
		background-color: #ff2930;
	}

	@keyframes btnlight {
		0% {
			transform: translate(0) rotate(45deg);
			transform-origin: 0 0;
		}

		100% {
			transform: translate(480px) rotate(45deg);
			transform-origin: 0 0;
		}
	}

	.bind_tips {
		text-align: center;
		color: #caaa66;
		font-size: 16px;
		margin-top: 80px;
	}

	.test_tips {
		font-size: 10px;
		color: #cccccc;
	}

	.fadein-enter-active {
		animation: fadein 0.5s;
	}
	.fadein-leave-active {
		animation: fadeout 0.5s;
	}
	@keyframes fadein {
		0% {
			bottom: -600px;
		}
		100% {
			bottom: 50px;
		}
	}
	@keyframes fadeout {
		0% {
			bottom: 50px;
		}
		100% {
			bottom: -600px;
		}
	}

	.error_tips_alert {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		z-index: 9;
		display: flex;
		justify-content: center;
		align-items: center;

		.error_tips_alert_content {
			width: 90%;
			max-width: 300px;
			padding: 2% 1%;
			border-radius: 10px;
			margin: 0 auto;
			background-color: rgba(255, 255, 255, 0.9);
			font-size: 14px;
			color: #333;
			display: block;
		}
	}
}

.index_ott {
	.top_nav_wrap {
		.login_btn {
			color: #dddddd;
			border: 2px solid #dddddd;
			background-color: transparent;
		}
		.login_btn:focus {
			color: #102961;
			border: 2px solid #efc65d;
			background-color: #efc65d;
			// transform: scale(1.2);
			box-shadow: 0px 0px 10px #ffffff;
			outline: none;
			-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		}
	}

	.body_left_arrow:focus {
		background-image: url(../assets/arrow_left_hover.png);
		// transform: scale(1.2);
		opacity: 1;
		outline: none;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}

	.body_right_arrow:focus {
		background-image: url(../assets/arrow_hover.png);
		// transform: scale(1.2);
		opacity: 1;
		outline: none;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}

	.test_btn {
		color: #102961;
	}
	.test_btn:focus {
		// transform: scale(1.2);
		background-color: transparent;
		border: 3px solid transparent;
		box-shadow: 0px 0px 15px #ffffff;
		outline: none;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}

	.pay_btn {
		color: #ffffff;
	}
	.pay_btn:focus {
		background-color: #ff2930;
		border: 3px solid #000000;
		color: #ffffff;
	}
}

@media screen and (max-width: 1440px) {
	.index {
		.body_title {
			margin-top: 100px;
		}
		.try_time_wrap {
			margin-top: -20px;
			margin-bottom: -45px;
			font-size: 14px;
		}
	}
}

@media screen and (max-width: 1050px) {
	.index {
		.body_left_arrow {
			left: 10%;
		}
		.body_right_arrow {
			right: 10%;
		}
		.body_qrcode {
			display: none;
		}
	}
}

@media screen and (max-width: 1000px) {
	.index {
		.top_wrap {
			.top_nav_wrap {
				margin-right: 20px;
				margin-top: 10px;
			}
		}
		.top_nav_logo {
			margin-left: 20px;
			img {
				width: 100px;
			}
		}
		.body_title {
			margin-top: 50px;
			width: 50%;
		}
		.tips_wrap {
			margin-top: -15px;
		}
		.tips_wrap {
			font-size: 14px;
			font {
				font-size: 12px;
			}
		}
		.test_btn {
			width: 150px;
			height: 35px;
			line-height: 35px;
			font-size: 16px;
			margin-top: 20px;
			margin-bottom: 10px;
		}
		.body_right_arrow {
			top: 180px;
			right: 25%;
			zoom: 0.5;
		}
		.body_left_arrow {
			top: 180px;
			left: 25%;
			zoom: 0.5;
		}
		.unpay_tips_wrap {
			margin-bottom: 30px;
		}
		.tips_btn_wrap {
			margin-top: 20px;
		}
	}
}
</style>